import { z } from 'zod';

import { CompanyAuditLogId, CompanyId, UserId } from '../BrandedIds';
import { zodDateOrString } from '../utils/Zod';

export const CompanyAuditLogEventType = z.enum([
  'addCompany',
  'updateCompany',
  'updateLogo',
  'updateCompanyAdminSettings',
  'updateCompanyPortalSettings',
  'deleteAllLoans',
  'deleteLoan',
  'deleteLoanWithoutAchPayments',
  'setPaymentsPaused',
  'updateCompanyTaskSettings',
  'updateCompanyReportSettings',
  'updateCompanyLoanControlSettings',
  'updateCompanyNonPerformanceAutomationSettings',
  'updatePortalSettings',

  'generatePortalDomainSslCert',
  'attachPortalDomainSslCert',
  'bulkSendEmails',

  'createCompanyWireSettings',
  'updateCompanyWireSettings',
  'setDefaultCompanyWireSettings',
  'deleteCompanyWireSettings',

  'createPayee',
  'updatePayee',
  'deletePayee',

  'updateCompanyInterestOnEscrowSettings',

  'createPool',
  'updatePool',
  'deletePool',

  'createCustodialAccount',
  'updateCustodialAccount',
  'deleteCustodialAccount',
  'recordCustodialAccountBalance',

  'createSftpSite',
  'updateSftpSite',
  'deleteSftpSite',
  'testSftpSite',

  'createSftpKey',
  'deleteSftpKey',

  'pinSftpHostKey',
  'unpinSftpHostKey',

  'addUserToCompany',
  'registerUserForCompany',
  'editUserForCompany',
  'deactivateUserForCompany',
  'updateUserCompanyAdminPermission',
  'migrateUserToSso',
  'migrateCompanyUsersToSso',

  'createTeam',
  'updateTeam',
  'deleteTeam',
]);
export type CompanyAuditLogEventType = z.infer<typeof CompanyAuditLogEventType>;

export const CompanyAuditLogEvent = z.object({
  id: CompanyAuditLogId,
  companyId: CompanyId,
  userId: UserId.optional(), // optional for preserving audit log items of deleted users
  type: CompanyAuditLogEventType,
  comment: z.string(),
  adminViewComment: z.string(),
  hidden: z.boolean(),
  createdAt: zodDateOrString,
  updatedAt: zodDateOrString,
});
export type CompanyAuditLogEvent = z.infer<typeof CompanyAuditLogEvent>;
